<template>
  <component
    :is="isMobile ? CoreBottomSheet : CoreDialog"
    v-model="invasiveServiceInfoStore.isOpenedPreliminaryConsultationModal"
    v-bind="isMobile
      ? { slotActionsClass: 'flex-column' }
      : { size: 'lg' }"
    data-qa="preliminary_consultation_modal"
  >
    <template
      v-if="!isMobile"
      #prependBtn="{ btnProps }"
    >
      <v-btn
        v-bind="btnProps"
        @click="invasiveServiceInfoStore.isOpenedPreliminaryConsultationModal = false"
      >
        <span class="ui-icon-close-not-a-circle" />
      </v-btn>
    </template>

    <template #default="{ xSpaceClass, counterXSpaceClass }">
      <v-img
        contain
        width="280"
        height="168"
        class="mx-auto mb-5"
        src="/static/_v1/pd/mascots/doctor-checking-pulse.svg"
        alt="Доктор проверяющий пульс - ПроДокторов"
        data-qa="preliminary_consultation_img"
      />
      <div
        class="text-h6 text--text text-center mb-2"
        data-qa="preliminary_consultation_title"
      >
        Сначала нужно проконсультироваться с врачом
      </div>
      <div
        class="text-body-1 text-secondary--text text-center"
        data-qa="preliminary_consultation_subtitle"
      >
        Он проверит наличие противопоказаний и при их отсутствии сможет выписать направление
      </div>

      <template
        v-if="invasiveServiceInfoStore.allowTreatmentReferral
          && !(
            invasiveServiceInfoStore.requiresPrimaryConsultation
            && invasiveServiceInfoStore.hasPrimaryConsultationDoctors
          )
          && invasiveServiceInfoStore.doctorSpecialities.length"
      >
        <div class="text-subtitle-1 text--text mt-5 mb-4">
          Выберите врача в вашем городе
        </div>
        <v-list :class="counterXSpaceClass">
          <v-list-item
            v-for="speciality in invasiveServiceInfoStore.doctorSpecialities"
            :key="speciality.name"
            :class="xSpaceClass"
            dense
            :href="speciality.url"
          >
            <v-list-item-icon class="align-self-center">
              <span class="ui-icon-doctor icon-secondary--text" />
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                <div class="text-body-1 text--text">
                  {{ speciality.name }}
                </div>
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <span class="ui-icon-arrow-right icon-secondary--text" />
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </template>
    </template>

    <template
      v-if="invasiveServiceInfoStore.requiresPrimaryConsultation && invasiveServiceInfoStore.hasPrimaryConsultationDoctors"
      #actions
    >
      <v-btn
        text
        color="text"
        data-qa="preliminary_consultation_btn_cancel"
        :class="{ 'order-1 w-100': isMobile }"
        @click="invasiveServiceInfoStore.isOpenedPreliminaryConsultationModal = false"
      >
        Закрыть
      </v-btn>
      <v-btn
        depressed
        color="primary"
        class="branding-btn branding-btn--primary rounded-20 text-none"
        data-qa="preliminary_consultation_btn_continue"
        :class="{ 'w-100': isMobile }"
        @click="invasiveServiceInfoStore.handleAppointment"
      >
        Записаться к врачу
      </v-btn>
    </template>
  </component>
</template>

<script lang="ts" setup>
import { nextTick, watch } from 'vue'
import scrollLock from 'src/utils/scrollLock'
import useYandexGoals from 'src/composables/useYandexGoals'
import CoreBottomSheet from 'src/core/CoreBottomSheet/CoreBottomSheet.vue'
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'
import useInvasiveServiceInfoStore from 'src/components/common/InvasiveServiceInfo/stores/useInvasiveServiceInfoStore'

const isMobile = window.MOBILE_VERSION
const { sendYaGoal } = useYandexGoals()

const invasiveServiceInfoStore = useInvasiveServiceInfoStore()

watch(() => invasiveServiceInfoStore.isOpenedPreliminaryConsultationModal, async value => {
  await nextTick() // дожидаемся рендера модалки чтобы получить содержимое через $refs

  scrollLock.set(value)

  if (value) {
    sendYaGoal('appointment__serviceOpenModalPreliminaryConsultation')
  } else {
    sendYaGoal('appointment__serviceClickDeclinePreliminaryConsultation')
  }
})
</script>
